// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1RzCL","label":"LabeledBox_label__b-H4s"};